const $ = require('cash-dom');
const Ajax = require('./ajax');

const DynamicData = {
  loaded: false,
  post_id: null,
  registered_for_observing: [],
  _active: function () {
    if (this.loaded) {
      return;
    }
    this.loaded = true;
    return $('.dynamic-data').length > 0;
  },
  _getDynamicDataFromElement: function (el) {
    let data = el.attr('data-dynamic-params');

    if (typeof data === 'undefined') {
      data = {};

      let elData = el.data();

      if (elData) {
        for (let key in elData) {
          if (elData.hasOwnProperty(key) && key.indexOf('dynamicParameter') === 0) {
            let formattedKey = key.replace('dynamicParameter', '').toLocaleLowerCase();
            data[formattedKey] = elData[key];
          }
        }
      }
    } else {
      data = JSON.parse(data);
    }

    if (data) {
      data['hash'] = el.attr('data-dynamic-hash');
      data['post_id'] = this.post_id;
    }

    return data;
  },
  _loadData: function (data) {
    let self = this;

    if (typeof data !== 'object' || !data.length) {
      return false;
    }

    Ajax.post(ajaxurl, {
      action: 'load-dynamic-data',
      post_id: self.post_id,
      data: data
    }, function (response) {
      response.forEach(function (item) {
        if (item['hash']) {

          let $container = $('[data-dynamic-hash="' + item['hash'] + '"]');

          if ($container.length > 0) {
            $container.each(function () {
              let $dynamic = item['result'] ? $($.parseHTML(item['result'])) : '';
              /**
               * For some HTML holders we need to load only plain text (no HTML), for example, for coupon-title shortcodes in quick nav
               * Please add class "dynamic-data-no-html" to the dynamic data holder and plain text will be loaded
               */
              if ($(this).closest('.dynamic-data-no-html').length > 0 && typeof $dynamic.text !== 'undefined') {
                $dynamic = $dynamic.text();
                $dynamic = document.createTextNode($dynamic);
              }

              if (item['result']) {
                $(this).replaceWith($dynamic);
              } else {
                $(this).remove();
              }
            });
          } else {
            //Search in meta attributes
            $('meta, head title').each(function () {
              let metaTag = $(this),
                content = metaTag.prop('tagName') === 'TITLE' ? metaTag.text() : metaTag.attr('content');

              if (typeof content !== 'undefined' && content.length && content.indexOf('dynamic-data') >= 0) {
                let $container = $('<div>' + content + '</div>').find('[data-dynamic-hash="' + item['hash'] + '"]');

                if ($container.length) {
                  let dataReplacer = item['result'] ? item['result'] : '';

                  content = content.replace($container.get(0).outerHTML, dataReplacer);

                  if (metaTag.prop('tagName') === 'TITLE') {
                    metaTag.text(content);
                  } else {
                    metaTag.attr('content', content);
                  }
                }
              }
            });
          }

          if (typeof applyAloomaTracking !== 'undefined') {
            applyAloomaTracking();
          }
        }
      });

      if (typeof response === 'object' && response.length) {
        self._loadLazy();
        self.update();
      }
    }, 'json');
  },
  _loadLazy: function () {
    let self = this;

    if (typeof window.IntersectionObserver !== 'undefined') {
      let observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0) {
            observer.unobserve(entry.target);

            let data = [self._getDynamicDataFromElement($(entry.target))];

            self._loadData(data);
          }
        });
      }, {
        rootMargin: '300px 0px',
        threshold: 0.01
      });

      $('.dynamic-data.lazy-dynamic').each(function () {
        let hash = $(this).attr('data-dynamic-hash');

        //prevent many-times observing
        if (typeof hash !== 'undefined' && hash.length && self.registered_for_observing.indexOf(hash) < 0) {
          self.registered_for_observing.push(hash);
          observer.observe(this);
        }
      });
    } else {
      self._loadNotLazy(true);
    }
  },
  _loadNotLazy: function (loadLazyElements) {
    let self = this,
      data = [],
      hashes = [],
      elements = loadLazyElements ? $('.dynamic-data.lazy-dynamic') : $('.dynamic-data:not(.lazy-dynamic)');

    elements.each(function () {
      let hash = $(this).attr('data-dynamic-hash');

      if (hash && hashes.indexOf(hash) < 0) {
        hashes.push(hash);

        data.push(self._getDynamicDataFromElement($(this)));
      }
    });

    $('meta, head title').each(function () {
      let content = $(this).prop('tagName') === 'TITLE' ? $(this).text() : $(this).attr('content');

      if (typeof content !== 'undefined' && content.length && content.indexOf('dynamic-data') >= 0) {
        let elements = $('<div>' + content + '</div>').find('.dynamic-data');

        elements.each(function () {
          let hash = $(this).attr('data-dynamic-hash');

          if (hash && hashes.indexOf(hash) < 0) {
            hashes.push(hash);

            data.push(self._getDynamicDataFromElement($(this)));
          }
        });
      }
    });

    self._loadData(data);
  },
  _createBlanks: function () {
    let self = this;

    $('.dynamic-data[data-dynamic-placeholders]').each(function () {
      let el = $(this),
        data = self._getDynamicDataFromElement(el),
        placeholders = parseInt($(this).attr('data-dynamic-placeholders'));

      if (!isNaN(placeholders) && typeof data['type'] !== 'undefined') {
        el.addClass(data['type'] + '-placeholders-container');

        for (placeholders; placeholders > 0; placeholders--) {
          let placeholder = $('<div/>');
          placeholder.addClass('card dynamic-data-placeholder ' + data['type'] + '-placeholder');
          placeholder.append('<div class="placeholder-inner card-body"><div class="placeholder-load"></div></div>');
          el.append(placeholder);
        }
      }
    });
  },
  update: function () {
    this._loadNotLazy();
  },
  init: function () {
    let self = this;

    self.post_id = $('body').first().attr('data-post-id');

    if (!self._active()) {
      return false;
    }

    //self._createBlanks();
    self._loadNotLazy();
    self._loadLazy();
  },
};

module.exports = DynamicData;
